import { TUser } from '@src/modules'
import { PresetStatusColorType } from 'antd/es/_util/colors'

export enum EActionList {
  EXPORT_EXCEL = 'Export excel',
  DELETE = 'Delete',
  IMPORT_DATA = 'Import data',
  IMPORT_POINT = 'Import point',
  CHANGE_POINT = 'Change point',
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export enum EStatusDoc {
  ACTIVE = 'active', // Đang hoạt động
  DRAFT = 'draft', // Dự thảo or nháp
  INACTIVE = 'inactive', // Không hoạt động
  PENDING = 'pending', // Chờ phê duyệt
}

export enum EStatusReward {
  COMPLETE = 'complete',
  CANCEL = 'cancel',
  PENDING = 'pending',
}

export enum ETargetNotification {
  ALL = 'ALL',
  OPTION = 'OPTION',
}
export enum EStatusDeal {
  NEW = 'NEW',
  OLD = 'OLD',
}

export enum EStatusDelete {
  COMPLETE = 'complete',
  CANCEL = 'cancel',
  PENDING = 'pending',
  DELETE = 'delete',
}

export type TStatusDocReward = {
  key: number
  value: EStatusReward
  status: PresetStatusColorType
}

export type TStatusDocDeal = {
  key: number
  value: EStatusDeal
  status: PresetStatusColorType
}

export type TStatusDocNoti = {
  key: number
  value: ETargetNotification
  status: PresetStatusColorType
}

export type TStatusDoc = {
  key: number
  value: EStatusDoc
  status: PresetStatusColorType
}

export enum ERole {
  GUEST = 'GUEST',
  EDITOR = 'EDITOR',
  ADMINISTRATOR = 'ADMINISTRATOR',
}

export enum ELanguage {
  VI = 'vi',
  EN = 'en',
  JA = 'ja',
}

// Post
export enum EPostFormat {
  HTML = 'HTML',
  PDF = 'PDF',
  VIDEO = 'VIDEO',
  WEBVIEW = 'WEBVIEW',
  GALLERY = 'GALLERY',
}

export type TPostReaction = {
  user: TUser
  react: EReactDoc
}

export enum EReactDoc {
  LIKE = 'like',
  WOW = 'wow',
  HEART = 'heart',
}

// Game
export enum EGameType {
  SINGLE = 'SINGLE',
  QUIZ = 'QUIZ',
  WHEEL = 'WHEEL',
}

export enum EGameWheelType {
  GIFT = 'GIFT',
  POINT = 'POINT',
}

export type TTranslationField<T = any> = {
  [key in ELanguage]: T
}

export type TDataInitTranslation = {
  lang: ELanguage
  translation: TTranslationField
  publishedLanguage?: ELanguage[]
  [key: string]: any
}

export enum EOrder {
  DESC = 'DESC',
  ASC = 'ASC',
}

export enum EOrderBy {
  ID = '_id',
  CREATED_DATE = 'createdAt',
  UPDATED_DATE = 'updatedAt',
  USERNAME = 'username',
  NAME = 'name',
  NAME_SORT = 'nameSort',
  VIEW_COUNT = 'viewCount',
}

export interface IStatusCode {
  statusCode: number
}

export interface IMessage {
  message: string
}

export interface ILimit {
  limit?: number
}

export interface IPage {
  page?: number
}

export interface IExtra<T = any> {
  [key: string]: T
}

export type TQueryParamsGetData<T = any> = ILimit &
  IPage & {
    order?: EOrder
    orderBy?: EOrderBy
    s?: string
    authorId?: string
  } & T

export type TResDataListApi<T = any, K = any> = {
  page: number
  limit: number
  total: number
} & { data: T } & IExtra<K>

export type TResApi<T = any, K = any> = IStatusCode & IMessage & { data: T } & IExtra<K>

export type TResApiErr<T = any, K = any> = IStatusCode &
  IMessage & {
    code: number
    message: string | string[]
    statusText: string
    status: number | string
    data: T
  } & IExtra<K>

export type TRemoveMany = {
  ids: string[]
}

export type TEditSlug = {
  slug: string
}

export type TOptionSelectSearch = {
  label: string
  value: string
  key?: string
}
